/**
 * DO NOT EDIT.
 *
 * This is Relay generated artifact.
 *
 * Please reach out to #jsm-cloud-megatron for any questions.
 *
 * @generated SignedSource<<20f16ca6be9cd34eb0197750c21b9865>>
 * @relayHash b9419fefe6eca5708d72652f26dc9a46
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c6d85878f880069e7fe7142858ac0bd22464d790f9d1663419d4e82b065a024c

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type HelpCenterDeleteInput = {
  helpCenterAri: string;
};
export type useHelpCenterDeleteMutation$variables = {
  cloudId: string;
  input: HelpCenterDeleteInput;
};
export type useHelpCenterDeleteMutation$data = {
  readonly helpCenter: {
    readonly deleteHelpCenter: {
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type useHelpCenterDeleteMutation = {
  response: useHelpCenterDeleteMutation$data;
  variables: useHelpCenterDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      }
    ],
    "concreteType": "HelpCenterMutationApi",
    "kind": "LinkedField",
    "name": "helpCenter",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "HelpCenterDeletePayload",
        "kind": "LinkedField",
        "name": "deleteHelpCenter",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "success",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "message",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useHelpCenterDeleteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useHelpCenterDeleteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "c6d85878f880069e7fe7142858ac0bd22464d790f9d1663419d4e82b065a024c",
    "metadata": {},
    "name": "useHelpCenterDeleteMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "7f1dd80d488ff1c4273819ebc7261544";

export default node;
